import * as React from "react";
import type { SVGProps } from "react";
const SvgPercent02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M20.537 12.06H3.463m9.75 4.607a1.8 1.8 0 1 1-2.546 2.545 1.8 1.8 0 0 1 2.545-2.545Zm0-11.88a1.8 1.8 0 1 1-2.546 2.546 1.8 1.8 0 0 1 2.545-2.545Z"
    />
  </svg>
);
export default SvgPercent02;
